// extracted by mini-css-extract-plugin
module.exports = {"page":"wM","account":"xM","pdp":"yM","cart":"zM","brand":"AM","cartModal":"BM","checkout":"CM"};